import { render, staticRenderFns } from "./AlertDialog.vue?vue&type=template&id=c5929dd2&scoped=true"
import script from "./AlertDialog.vue?vue&type=script&lang=ts"
export * from "./AlertDialog.vue?vue&type=script&lang=ts"
import style0 from "./AlertDialog.vue?vue&type=style&index=0&id=c5929dd2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5929dd2",
  null
  
)

export default component.exports